import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  baseGetWithoutParam,
  basePostArray,
  baseGet
} from 'services/base-services/baseService';
const baseURL = `${API2_HOST}/suppliers`;

const importSupplier = async request => {
  return await basePostArray(baseURL, request);
};

const getSupplierDetails = async id => {
  const res = await baseGet(`${baseURL}`, id);
  return res;
};

const SOURCE_SUPPLIERS_TIMEOUT_MS = 20000;

const getWDSuppliers = async signal => {
  return await baseGetWithoutParam(`${baseURL}/source-wd`, {
    timeout: SOURCE_SUPPLIERS_TIMEOUT_MS,
    signal
  });
};

const getEVASuppliers = async signal => {
  return await baseGetWithoutParam(`${baseURL}/source-eva`, {
    timeout: SOURCE_SUPPLIERS_TIMEOUT_MS,
    signal
  });
};

const searchSuppliers = async request => {
  const res = await baseSearch(baseURL, request);
  return res;
};

export {
  getEVASuppliers,
  getSupplierDetails,
  getWDSuppliers,
  searchSuppliers,
  importSupplier
};
